import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { Typography, Button, InputLabel, Grid, Paper } from "@material-ui/core";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Axios } from "../../../config/axios";
import Direccion from "../../../utils/Direccion";
import {
  GET_DEPARTMENTS,
  GET_MUNICIPALITIES,
  CREATE_STORE,
  GET_CATEGORIES,
} from "../../../constants";
import Select from "react-dropdown-select";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import moment from "moment";
import { getTime } from "../../../utils/date";
import toast from "toasted-notes";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  form: {
    "& > *": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
  paper: {
    margin: theme.spacing(4, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  // paper: {
  //   padding: theme.spacing(2),
  //   textAlign: "center",
  //   color: theme.palette.text.secondary,
  // },
  title: {
    flexGrow: 1,
    margin: "1rem",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export const ShopForm = ({ setForm }) => {
  const classes = useStyles();
  const [deps, setDeps] = useState([]);
  const [dep, setDep] = useState("");
  const [munis, setMunis] = useState([]);
  const [mun, setMun] = useState("");
  const [horaInicial, setHoraInicial] = useState(new Date());
  const [horaFinal, setHoraFinal] = useState(new Date());
  const [categories, setCategories] = useState([]);
  const [cat, setCat] = useState("");

  const [error, setError] = useState({});
  const [departamentos, setDepartamentos] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [Cobertura, setCobertura] = useState(true); 
  const [departamento, setDepartamento] = useState("NONE");
  const [municipio, setMunicipio] = useState("NONE");
  const [direccion, setDireccion] = useState();  
  const [referencia, setReferencia] = useState();
  const [complemento, setComplemento] = useState();
  const [latitud, setLatitud] = useState();
  const [longitud, setLongitud] = useState();

  const getDepartments = async () => {
    Axios.get(GET_DEPARTMENTS)
      .then((res) => {
        setDeps(res.data);
        setDep(res.data[18]);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getMunicipalities = (id) => {
    Axios.get(GET_MUNICIPALITIES + id)
      .then((res) => {
        setMunis(res.data);
        setMun(res.data[0]);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getCategories = async () => {
    Axios.get(`${GET_CATEGORIES}?type=${1}`)
      .then((res) => {
        setCategories(res.data);
        setCat(res.data[0]);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getDepartments();
    getCategories();
  }, []);

  const formik = useFormik({
    initialValues: {
      nit: "",
      nombre: "",
      representante: "",
      razonSocial: "",
      telefono: "",
      celular1: "",
      celular2: "",
      direccion: "",
      usuario: "",
      clave: "",
      valorDomicilio: 0,
      valorPedidoMinimo: 0,
      rangoEnMetros: 0,
    },
    validationSchema: Yup.object({
      nit: Yup.string().required("El Nit es requerido"),
      nombre: Yup.string().required("El Nombre es requerido"),
      representante: Yup.string().required("El Representante es requerido"),
      razonSocial: Yup.string().required("La Razon social es requeridad"),
      telefono: Yup.string().required("El telefono es requerido"),
      usuario: Yup.string().required("El Usuario es requerido"),
      clave: Yup.string().required("La Clave es requerida"),
      valorDomicilio: Yup.number()
        .min(0, "El valor del domicilio no puede ser 0")
        .required("El Valor del domicilio es requerido"),
      valorPedidoMinimo: Yup.number()
        .min(0, "El valor del pedido minimo no puede ser 0")
        .required("El Valor del pedido minimo es requerido"),
      rangoEnMetros: Yup.number()
        .min(0, "El rango de metros no puede ser 0")
        .required("El Rango en metros es requerido"),
    }),
    onSubmit: (values) => {
      //Nit, Nombre, Representante, RazonSocial, Telefono, Celular1, Celular2, Direccion, Usuario, Clave, ValorDomicilio, ValorPedidoMinimo, RangoEnMetros, CodMunicipio
      const data = {
        nit: values.nit,
        nombre: values.nombre,
        representante: values.representante,
        razonSocial: values.razonSocial,
        telefono: values.telefono,
        celular1: values.celular1,
        celular2: values.celular2,
        direccion: direccion ? direccion + " " +complemento : "",
        usuario: values.usuario,
        clave: values.clave,
        valorDomicilio: values.valorDomicilio,
        valorPedidoMinimo: values.valorPedidoMinimo,
        latitud: latitud ? latitud : 0,
        longitud : longitud ? longitud : 0,
        rangoEnMetros: values.rangoEnMetros,
        codMunicipio: municipio[0].Codigo,
        codCategoria: cat.Codigo,
      };
      console.log(data);
      Axios.post(CREATE_STORE, data)
        .then((res) => {
          console.log(res);
          if(res.status===200){
            toast.notify("Tienda Creada Correctamente");
          setForm(false);
          }
          if(res.status===202){
            toast.notify(res.data.Mensaje);
          }          
        })
        .catch((err) => {
          console.log(err);
          toast.notify("Hubo un error al crear la tienda");
        });
    },
  });

  const handleChange = (value) => {
    setDepartamento(value)
    getMunicipalities(value[0].Codigo);
  };

  return (
    <div>
      <div className={classes.root}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Typography
                component="h3"
                variant="h6"
                style={{ color: "#707070" }}
                noWrap
              >
                Nueva Tienda
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <Paper className={classes.paper}>
              <form
                noValidate
                autoComplete="off"
                onSubmit={formik.handleSubmit}
                className={classes.form}
              >
                <TextField
                  id="standard-basic"
                  label="Nit"
                  name="nit"
                  variant="outlined"
                  onChange={formik.handleChange}
                  value={formik.values.nit}
                  helperText={formik.touched.nit && formik.errors.nit}
                  error={formik.touched.nit && formik.errors.nit ? true : false}
                />
                <TextField
                  id="standard-basic"
                  label="Nombre"
                  name="nombre"
                  variant="outlined"
                  autoFocus
                  onChange={formik.handleChange}
                  value={formik.values.nombre}
                  helperText={formik.touched.nombre && formik.errors.nombre}
                  error={
                    formik.touched.nombre && formik.errors.nombre ? true : false
                  }
                />
                <TextField
                  id="standard-basic"
                  label="Representante"
                  name="representante"
                  variant="outlined"
                  onChange={formik.handleChange}
                  value={formik.values.representante}
                  helperText={
                    formik.touched.representante && formik.errors.representante
                  }
                  error={
                    formik.touched.representante && formik.errors.representante
                      ? true
                      : false
                  }
                />
                <TextField
                  id="standard-basic"
                  label="Usuario"
                  name="usuario"
                  variant="outlined"
                  onChange={formik.handleChange}
                  value={formik.values.usuario}
                  helperText={formik.touched.usuario && formik.errors.usuario}
                  error={
                    formik.touched.usuario && formik.errors.usuario
                      ? true
                      : false
                  }
                />
                <TextField
                  id="standard-basic"
                  label="Clave"
                  name="clave"
                  type="password"
                  variant="outlined"
                  onChange={formik.handleChange}
                  value={formik.values.clave}
                  helperText={formik.touched.clave && formik.errors.clave}
                  error={
                    formik.touched.clave && formik.errors.clave ? true : false
                  }
                />
                <TextField
                  id="standard-basic"
                  label="Razon Social"
                  name="razonSocial"
                  variant="outlined"
                  onChange={formik.handleChange}
                  value={formik.values.razonSocial}
                  helperText={
                    formik.touched.razonSocial && formik.errors.razonSocial
                  }
                  error={
                    formik.touched.razonSocial && formik.errors.razonSocial
                      ? true
                      : false
                  }
                />
                <TextField
                  id="standard-basic"
                  label="Telefono"
                  name="telefono"
                  variant="outlined"
                  onChange={formik.handleChange}
                  value={formik.values.telefono}
                  helperText={formik.touched.telefono && formik.errors.telefono}
                  error={
                    formik.touched.telefono && formik.errors.telefono
                      ? true
                      : false
                  }
                />
                <TextField
                  id="standard-basic"
                  label="Celular1"
                  name="celular1"
                  variant="outlined"
                  onChange={formik.handleChange}
                  value={formik.values.celular1}
                />
                <TextField
                  id="standard-basic"
                  label="Celular2"
                  name="celular2"
                  variant="outlined"
                  onChange={formik.handleChange}
                  value={formik.values.celular2}
                />
               
                <TextField
                  id="standard-basic"
                  label="Valor Domicilio"
                  name="valorDomicilio"
                  variant="outlined"
                  type="number"
                  onChange={formik.handleChange}
                  value={formik.values.valorDomicilio}
                  helperText={
                    formik.touched.valorDomicilio &&
                    formik.errors.valorDomicilio
                  }
                  error={
                    formik.touched.valorDomicilio &&
                    formik.errors.valorDomicilio
                      ? true
                      : false
                  }
                />
                <TextField
                  id="standard-basic"
                  label="Valor Pedido Minimo"
                  name="valorPedidoMinimo"
                  variant="outlined"
                  type="number"
                  onChange={formik.handleChange}
                  value={formik.values.valorPedidoMinimo}
                  helperText={
                    formik.touched.valorPedidoMinimo &&
                    formik.errors.valorPedidoMinimo
                  }
                  error={
                    formik.touched.valorPedidoMinimo &&
                    formik.errors.valorPedidoMinimo
                      ? true
                      : false
                  }
                />
                <TextField
                  id="standard-basic"
                  label="Rango en Metros"
                  name="rangoEnMetros"
                  variant="outlined"
                  type="number"
                  onChange={formik.handleChange}
                  value={formik.values.rangoEnMetros}
                  helperText={
                    formik.touched.rangoEnMetros && formik.errors.rangoEnMetros
                  }
                  error={
                    formik.touched.rangoEnMetros && formik.errors.rangoEnMetros
                      ? true
                      : false
                  }
                />
                  <InputLabel id="demo-simple-select-label">Categoria</InputLabel>
                  <Select
                    style={{
                      marginTop: "1rem",
                      borderRadius: "7px",
                      height: "55px",
                    }}
                    color="#8900D8"
                    options={categories}
                    labelField="Nombre"
                    valueField="Codigo"
                    onChange={(value) => setCat(value[0])}
                    values={[cat]}
                  />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  style={{ backgroundColor: "#8900D8", color: "white" }}
                  className={classes.submit}
                >
                  Registrar Tienda
                </Button>
              </form>
            </Paper>
          </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <Paper className={classes.paper}>
                <form noValidate autoComplete="off" onSubmit={formik.handleSubmit} className={classes.form}>
                  <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    columnGap: "10px",
                    justifyContent: "center",
                    margin: "0,5rem",
                  }}
                >
                  <div>
                    <InputLabel id="demo-simple-select-label">
                      Departamento
                    </InputLabel>
                    <Select
                      style={{
                        marginTop: "1rem",
                        borderRadius: "7px",
                        height: "55px",
                      }}
                      color="#8900D8"
                      options={deps}
                      labelField="Nombre"
                      valueField="Codigo"
                      onChange={(value) => handleChange(value)}
                      values={[dep]}
                    />
                  </div>

                  <div>
                    <InputLabel id="demo-simple-select-label">
                      Municipio
                    </InputLabel>
                    <Select
                      style={{
                        marginTop: "1rem",
                        borderRadius: "7px",
                        height: "55px",
                      }}
                      color="#8900D8"
                      options={munis}
                      labelField="Nombre"
                      valueField="Codigo"
                      onChange={(value) => setMunicipio(value)}
                      values={[mun]}
                    />
                  </div>
                </div>
                </form>
                <Direccion 
                    departamento={departamento}
                    municipio={municipio}
                    direccion={direccion}
                    complemento={complemento}
                    latitud={latitud}
                    longitud={longitud}
                    updateDireccion={setDireccion}
                    updateComplemento={setComplemento}
                    updateLatitud={setLatitud}
                    updateLongitud={setLongitud}
                    error={error}/>
              </Paper>
            </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <Paper className={classes.paper}>
              {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <KeyboardTimePicker
                    margin="normal"
                    id="time-picker"
                    label="Hora de apertura"
                    onChange={(date) => setHoraInicial(date)}
                    value={horaInicial}
                    KeyboardButtonProps={{
                      "aria-label": "change time",
                    }}
                  />
                  <KeyboardTimePicker
                    margin="normal"
                    id="time-picker"
                    label="Hora de cierre"
                    onChange={(date) => setHoraFinal(date)}
                    value={horaFinal}
                    KeyboardButtonProps={{
                      "aria-label": "change time",
                    }}
                  />
                </Grid>
              </MuiPickersUtilsProvider> */}
            </Paper>
          </Grid>
          {/* </form> */}
        </Grid>
      </div>
    </div>
  );
};
